var jBody = $('body');
jBody.on('click', 'a[data-confirm],button[data-confirm]', function (e) {//a confirm
    var r = confirm($(this).data("confirm"));
    if (r !== true) {
        e.preventDefault();
    } else {
        $(this).trigger('click-confirmed', e);
    }
})

// Custom confirmation modal
jBody.on('click', 'a[data-confirm-modal]', function (e, confirmed) {
    if (confirmed === true) {
        return true;
    }

    let currentBtn = e.target;

    let $link = $(this);
    let href = $link.data('src') || '';
    let hrefAttr = (href) ? ' href="' + href + '"' : '';
    let action = $link.data('action') || '';
    let actionAttr = (action) ? ' data-action="' + action + '"' : '';
    let classN = $link.data('class') || '';
    let i18nClose = $('#i18n_close').length ? $('#i18n_close').val() : 'Uždaryti';

    let dataAttr = '', className = '';

    var modalHtml =
        '<div class="modal fade modal-ajax-form" tabindex="-1" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">'
        + '<div class="modal-dialog modal-dialog-centered">'
        + '<div class="modal-content rounded-0">'
        + '<div class="modal-header">'
        + '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>'
        + '</div>'
        + '<div class="modal-body">'
        // + '<img src="/Project/Modules/General/Admin/assets/images/icons/icon-info.svg"/>'
        + '<h3 class="modal-title fw-bold">' + $link.data('confirm-modal') + '</h3>'
        + '</div>'
        + '<div class="modal-footer py-3">'
        + '<a' + hrefAttr + ' class="btn btn-primary btn-href px-5' + ((!href) ? ' d-none' : className) + '"' + dataAttr + '>'
        + ($link.data('btn-ok') || 'OK') + '</a>'
        + '<a' + actionAttr + ' data-bs-dismiss="modal" aria-label="Close"  class="btn btn-action btn-primary px-5 ' + classN + '' + ((!action) ? ' d-none' : className) + '"' + actionAttr + '>'
        + ($link.data('btn-ok') || 'OK') + '</a>'
        + '<button type="button" class="btn btn-primary close-modal px-5" data-bs-dismiss="modal" aria-label="Close">' + i18nClose + '</button>'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>';

    let $modal = $(modalHtml);

    $(document).on("click", ".btn-action", function () {
        $(currentBtn).removeAttr('data-confirm-modal');
        $(currentBtn).addClass(classN);
        $(currentBtn).trigger('click');
    });

    $('body').append($modal);

    let modal_inst = new bootstrap.Modal($modal);
    modal_inst.show();

    $modal.modal({}).on('hidden.bs.modal', function () {
        $modal.remove();
    });

    return false;
});